import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@@common';

import { DataSchemaClient, SchemaTypes, SchemaTypesModel } from '../../../api/api';
import { contextDesignerQueryKeys } from '../ContextDesignerQueryKeys';

export function useDomainModel(contextId: string) {
	const dataSchemaClient = useApiClient(DataSchemaClient);

	return useQuery({
		queryKey: contextDesignerQueryKeys.domainModel(contextId),
		queryFn: () =>
			dataSchemaClient.getDomainModel(contextId, [
				SchemaTypesModel.DataSchema,
				SchemaTypesModel.RootDataSchema,
				SchemaTypesModel.DataOperationRequestSchema,
				SchemaTypesModel.DataOperationResponseSchema,
				SchemaTypesModel.DataReadSchema,
				// The generated model enum currently omits DTO schema, although the API contract exposes it.
				SchemaTypes.DTOSchema as unknown as SchemaTypesModel,
			]),
		enabled: !!contextId,
		staleTime: 60000,
		gcTime: 5 * 60 * 1000,
	});
}
